"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schedule = void 0;
var moment = require("moment");
var common_1 = require("../../schemas/common");
var index_1 = require("./index");
var Schedule = /** @class */ (function (_super) {
    __extends(Schedule, _super);
    function Schedule(props) {
        if (props === void 0) { props = {}; }
        var _this = _super.call(this, __assign(__assign({}, Schedule.defaultProps()), props)) || this;
        _super.prototype.set.call(_this, Schedule.defaultProps());
        _this.set(props);
        return _this;
    }
    Schedule.adjustRate = function (schedule) {
        var start = moment(schedule.startDate);
        var repeatCount = schedule.repeatCount;
        var end = start.clone();
        for (var i = 0; i < repeatCount; i++) {
            end.add(schedule.repeatFrequency.value, schedule.repeatFrequency.unit);
        }
        schedule.endDate = end.toISOString();
        return schedule;
    };
    Schedule.defaultProps = function (repeat) {
        if (repeat === void 0) { repeat = 4; }
        var start = moment().add(1, 'hour');
        var end = start.clone();
        for (var i = 0; i < repeat; i++) {
            end.add(1, 'week');
            var e = start.clone().add(repeat, 'weeks');
        }
        return {
            by: {
                weekDay: start.format('dddd').toLowerCase(),
            },
            duration: {
                value: 1,
                unit: 'hour'
            },
            startDate: start.startOf('day').toISOString(),
            endDate: end.endOf('day').toISOString(),
            startTime: {
                h: 12,
                m: 0
            },
            endTime: {
                h: 13,
                m: 0
            },
            exceptDates: [],
            repeatCount: 4,
            repeatFrequency: {
                value: 1,
                unit: 'weeks'
            },
            scheduleTimezone: common_1.Timezone['America/Los_Angeles']
        };
    };
    return Schedule;
}(index_1.AbstractModelLight));
exports.Schedule = Schedule;
